import { Component, Prop, Vue } from 'vue-property-decorator'
import { VImg, VLayout, VSheet } from 'vuetify/lib'
import './Error.scss'

@Component({})
export class ErrorPage extends Vue {
	@Prop({ type: String }) message!: string
	@Prop({ type: String }) title!: string
	@Prop({ type: String }) image!: string

	get height() {
		return this.$vuetify.breakpoint.height - 250
	}

	public render() {
		return (
			<VLayout id="app-error-page" column class="fade-in">
				<VSheet elevation="0" class="d-flex justify-center align-center" height={this.height}>
					<div class="app-error-page--text" align="center">
						<VImg class="mx-auto pb-6 fade-in" src={this.image} cover width="300" />
						<h1 class="font-weight-bold text-center pb-4 mt-10 title-card">{this.title}</h1>
						<p class="text-subtitle">{this.message}</p>
					</div>
				</VSheet>
			</VLayout>
		)
	}
}

export default ErrorPage
